import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Star05 = function Star05(props) {
  return /*#__PURE__*/_jsxs("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props, {
    children: [/*#__PURE__*/_jsx("path", {
      fill: "#fff",
      fillOpacity: 0.01,
      d: "m12 2 1.1713 4.6854c.2286.9143.3429 1.3714.5809 1.7434.2106.329.49.6084.819.819.372.238.8291.3523 1.7434.5808L21 11l-4.6854 1.1713c-.9143.2286-1.3714.3429-1.7434.5809a2.702 2.702 0 0 0-.819.819c-.238.372-.3523.8291-.5809 1.7434L12 20l-1.1713-4.6854c-.2286-.9143-.3429-1.3714-.5809-1.7434a2.7017 2.7017 0 0 0-.819-.819c-.372-.238-.8291-.3523-1.7434-.5809L3 11l4.6854-1.1714c.9143-.2285 1.3714-.3428 1.7434-.5808a2.702 2.702 0 0 0 .819-.819c.238-.372.3523-.8291.5809-1.7434L12 2Z"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#fff",
      fillOpacity: 0.01,
      d: "m12 2 1.1713 4.6854c.2286.9143.3429 1.3714.5809 1.7434.2106.329.49.6084.819.819.372.238.8291.3523 1.7434.5808L21 11l-4.6854 1.1713c-.9143.2286-1.3714.3429-1.7434.5809a2.702 2.702 0 0 0-.819.819c-.238.372-.3523.8291-.5809 1.7434L12 20l-1.1713-4.6854c-.2286-.9143-.3429-1.3714-.5809-1.7434a2.7017 2.7017 0 0 0-.819-.819c-.372-.238-.8291-.3523-1.7434-.5809L3 11l4.6854-1.1714c.9143-.2285 1.3714-.3428 1.7434-.5808a2.702 2.702 0 0 0 .819-.819c.238-.372.3523-.8291.5809-1.7434L12 2Z"
    }), /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "m12 2 1.1713 4.6854c.2286.9143.3429 1.3714.5809 1.7434.2106.329.49.6084.819.819.372.238.8291.3523 1.7434.5808L21 11l-4.6854 1.1713c-.9143.2286-1.3714.3429-1.7434.5809a2.702 2.702 0 0 0-.819.819c-.238.372-.3523.8291-.5809 1.7434L12 20l-1.1713-4.6854c-.2286-.9143-.3429-1.3714-.5809-1.7434a2.7017 2.7017 0 0 0-.819-.819c-.372-.238-.8291-.3523-1.7434-.5809L3 11l4.6854-1.1714c.9143-.2285 1.3714-.3428 1.7434-.5808a2.702 2.702 0 0 0 .819-.819c.238-.372.3523-.8291.5809-1.7434L12 2Z"
    }), /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "m12 2 1.1713 4.6854c.2286.9143.3429 1.3714.5809 1.7434.2106.329.49.6084.819.819.372.238.8291.3523 1.7434.5808L21 11l-4.6854 1.1713c-.9143.2286-1.3714.3429-1.7434.5809a2.702 2.702 0 0 0-.819.819c-.238.372-.3523.8291-.5809 1.7434L12 20l-1.1713-4.6854c-.2286-.9143-.3429-1.3714-.5809-1.7434a2.7017 2.7017 0 0 0-.819-.819c-.372-.238-.8291-.3523-1.7434-.5809L3 11l4.6854-1.1714c.9143-.2285 1.3714-.3428 1.7434-.5808a2.702 2.702 0 0 0 .819-.819c.238-.372.3523-.8291.5809-1.7434L12 2Z"
    })]
  }));
};
export default Star05;